import { createSelector } from 'reselect';
import { lastRoundHighsSelector } from './simple-selectors';

export const lastRoundHighsSeasonDataSelector = createSelector(
    lastRoundHighsSelector,
    // @ts-ignore
    (lastRoundHighs) => lastRoundHighs.seasonData
);
